
/**
 * The type of (redux) action to add the timer when the conference starts.
 *
 * {
 *     type: ADD_TIMER,
 *     timer: string
 * }.
 */
export const ADD_TIMER = 'ADD_TIMER';

/**
 * The type of (redux) action to add the timer when the conference starts.
 *
 * {
 *     type: POLLS_TAB_FOCUSED,
 *     pollsTabFocused: boolean
 * }.
 */
export const POLLS_TAB_FOCUSED = 'POLLS_TAB_FOCUSED';

/**
 * The type of (redux) action to add the timer when the conference starts.
 *
 * {
 *     type: FILM_STRIP_VIEW,
 *     filmStripView: string
 * }.
 */
export const FILM_STRIP_VIEW = 'FILM_STRIP_VIEW';


/**
 * The type of (redux) action to add the timer when the conference starts.
 *
 * {
 *     type: CONFERENCE_SUBJECT,
 *     conferenceSubject: string
 * }.
 */
export const CONFERENCE_SUBJECT = 'CONFERENCE_SUBJECT';


/**
 * The type of (redux) action to add the timer when the conference starts.
 *
 * {
 *     type: CONFERENCE_VIEW,
 *     conferenceview: string
 * }.
 */
export const CONFERENCE_VIEW = 'CONFERENCE_VIEW';

/**
 * The type of (redux) action to add the timer when the conference starts.
 *
 * {
 *     type: COLOR_PICKER,
 *     colorPicker: string
 * }.
 */
export const COLOR_PICKER = 'COLOR_PICKER';

/**
 * The type of (redux) action to set whether the meeting limit is exceeded.
 *
 * {
 *     type: SET_MEETING_LIMIT_EXCEEDED,
 *     isExceeded: boolean,
 *     details?: Object
 * }.
 */
export const SET_MEETING_LIMIT_EXCEEDED = 'SET_MEETING_LIMIT_EXCEEDED';

/**
 * The command name used for broadcasting meeting limit exceeded state via XMPP presence.
 */
export const MEETING_LIMIT_EXCEEDED_COMMAND = 'MEETING_LIMIT_EXCEEDED';
